import script from "./Lessons.vue?vue&type=script&setup=true&lang=ts"
export * from "./Lessons.vue?vue&type=script&setup=true&lang=ts"

import "./Lessons.vue?vue&type=style&index=0&id=9c3636b6&scoped=true&lang=scss"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c3636b6"]])

export default __exports__